import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './utils';
import { RootState } from '../../../../store';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { SettingsTabs } from './types';

const sliceName = 'settingsView';

// =============================
// ------- Slice ----------
// =============================
const settingsViewSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    settingsViewInit: (state) => {},
    settingsViewSetActiveTab: (
      state,
      { payload: newActiveTab }: PayloadAction<SettingsTabs>,
    ) => {
      state.activeTab = newActiveTab;
    },
    settingsViewOnChangeActiveTab: (
      state,
      { payload: newActiveTab }: PayloadAction<SettingsTabs>,
    ) => {
      state.activeTab = newActiveTab;
    },
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getSettingsViewActiveTab = (state: RootState) =>
  state.settingsView.activeTab;

// =============================
// ------- Exports ----------
// =============================

export const {
  settingsViewInit,
  settingsViewSetActiveTab,
  settingsViewOnChangeActiveTab,
} = settingsViewSlice.actions;

export default settingsViewSlice.reducer;
